module.exports = __webpack_public_path__ + "static/media/VanWalksLanding.4667265a.png";